
import { defineComponent } from 'vue'

interface ZRadioGroupT extends Vue {
  modelValue: string
  value?: string
  disabled: boolean
  readOnly: boolean
}

export default defineComponent({
  name: 'ZRadioButton',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    label: {
      type: String
    },
    value: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    spacing: {
      type: String,
      default: 'px-3 py-2'
    },
    borderColor: {
      type: String,
      default: 'border-ink-200',
      validator: (val: string) => val.startsWith('border-')
    }
  },
  computed: {
    modelData(): string {
      const $parent = this.$parent as ZRadioGroupT
      return $parent?.modelValue || this.modelValue
    },
    isChecked(): boolean {
      return this.modelData === this.value
    },
    isDisabled(): boolean {
      const $parent = this.$parent as ZRadioGroupT
      return $parent?.disabled || this.disabled
    }
  },
  methods: {
    updateInput() {
      const $parent = this.$parent as ZRadioGroupT
      $parent.value = this.value
    }
  }
})
